export enum AlternateOrderValidationWarning {
  CUSTOMER_NOTE_TOO_LONG = 'customer_note_too_long',
  INACTIVE_BILL_TO_PROJECT_LINK = 'inactive_bill_to_project_link',
  INACTIVE_SHIP_TO_PROJECT_LINK = 'inactive_ship_to_project_link',
  MISSING_AR_NUMBER = 'missing_ar_number',
  MISSING_ISR_EMPLOYEE = 'missing_isr_employee',
  MISSING_OSR_EMPLOYEE = 'missing_osr_employee',
  PURCHASE_ORDER_NUMBER_TOO_LONG = 'purchase_order_number_too_long',
}
